import React, {Component} from 'react';
import { isBeforeDate, sendMailById, refreshStatus, newReviseUser, putToast, reviseTUser} from "../../api";
import TournamentProfile from "../../pages/pageParts/inputForms/tournamentProfileForm"
import AvatarDisplay from "../../common/avatarDisplay"
import TUserBox from './workflow/tUserBox'
import {Link} from 'react-router-dom'
import './tournament.css'

const TOURNAMENT_WELCOME_COMPETITOR_EMAIL_TEMPLATE = process.env.REACT_APP_TOURNAMENT_WELCOME_COMPETITOR_EMAIL_TEMPLATE;
const TOURNAMENT_WELCOME_JUDGE_EMAIL_TEMPLATE = process.env.REACT_APP_TOURNAMENT_WELCOME_JUDGE_EMAIL_TEMPLATE;
const TOURNAMENT_WELCOME_GUEST_EMAIL_TEMPLATE = process.env.REACT_APP_TOURNAMENT_WELCOME_GUEST_EMAIL_TEMPLATE;

class TournamentGuide extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            user: this.props.user,
            tUser: this.props.tUser,
            tData: this.props.tData,
            newUser: {accountType: null},
        }

    }

    onCloseTournamentProfileModal = (mode, values) => {
        if (mode === 'tournamentProfile') {
            let user = this.state.user;
            let tUser = this.state.tUser;
            
            // change the user
            // note, we are saving locally here to the user, but using the values object to send to the server
            // this keeps us ok.
            user.club = values.club
            user.experience = values.experience
            user.ageGroup = values.age
            user.gender = values.gender
            user.phone = values.phone
            user.plainPhone = user.phone.replace(/[^0-9]/g, '');

            values.ageGroup = values.age;
            
            newReviseUser({club: values.club, experience: values.experience, ageGroup: values.age, 
                gender: values.gender, phone: values.phone, plainPhone:  values.phone.replace(/[^0-9]/g, '')}, user._id)
            .then(d2 => { 
                // change the tUser
                tUser.isGuest = values.judgeClass === 'guest';
                tUser.isCompetitor = values.judgeClass === 'competitor';
                tUser.isJudge = !(tUser.isGuest || tUser.isCompetitor)
                
                if (!tUser.isProfileComplete) { // send notification the first time they finish profile
                    if (tUser.isJudge) sendMailById(TOURNAMENT_WELCOME_JUDGE_EMAIL_TEMPLATE, [tUser.userId], {tournament: this.state.tData._id})
                    if (tUser.isCompetitor) sendMailById(TOURNAMENT_WELCOME_COMPETITOR_EMAIL_TEMPLATE, [tUser.userId], {tournament: this.state.tData._id})
                    if (tUser.isGuest) sendMailById(TOURNAMENT_WELCOME_GUEST_EMAIL_TEMPLATE, [tUser.userId], {tournament: this.state.tData._id})
                }

                tUser.isProfileComplete = true;
                tUser.status = 'Pending'

                tUser.displayname = user.displayname;
                tUser.firstname = user.firstname;
                tUser.lastname = user.lastname;
                tUser.email = user.email;
                tUser.phone = user.phone;
                tUser.gender = user.gender;
                tUser.experience = user.experience;
                tUser.ageGroup = user.ageGroup;
                tUser.club = user.club;
                tUser.plainPhone = user.plainPhone;

                tUser.judgeClass = values.judgeClass;
                tUser.guestOfEmail = values.guestOfEmail

                reviseTUser(tUser).then(d3 => {
                    if (!d3 || d3.error) {
                        console.log(d3 ? d3.error : "Error - no data");
                        putToast.error(d3 ? d3.error : "Error - no data");
                    } else {
                        putToast.success(d3.message);
                        this.setState({ open: false, user: user, tUser: d3.tUser}); 
                    }
                });

                if (this.props.onUpdate) this.props.onUpdate(this.state.tUser);
            })
        } 
    };
    
    onRefreshStatus = () => {
        refreshStatus(this.state.tData._id).then(d2 => {
            if (!d2 || d2.error) {
                console.log(d2 ? d2.error : "Error - no data");
                putToast.error(d2 ? d2.error : "Error - no data");
            } else {
                putToast.success(d2.message);    
                this.setState({ tUser: d2.tUser});   
            }
        }); 
    };


    componentDidUpdate(prevProps) {
        if(prevProps.tData !== this.props.tData || prevProps.user !== this.props.user || prevProps.tUser !== this.props.tUser) {
            this.setState({ tData: this.props.tData, tUser: this.props.tUser, user: this.props.user });
        }
    }
    

    renderStepAdmin(status) {
        switch(status) {
            default: 
            return {
                color: "bg-info",
                title: <h4>Welcome to the tournament!</h4>, 
                body: <p>Let's get you setup to participate. To get started, please click the Edit Profile button to the right (or below) and configure your tournament profile.  This information will only be used to ensure proper room assignments during the tournament and in case of the need to immediately contact you. </p>
            }
        }        
    }

    renderStepGuest(status) {
        switch(status) {
            case "Validating":
            return {
                color: "bg-warning",
                title: <h4>Validating your guest status</h4>, 
                body: 
                <>
                <p>We are attempting to match the email you entered for the person on whom's behalf you were attending the tournament.  Once this has been verified, your status will change to Observing.</p>
                </>
            }               

            default: 
            return {
                color: "bg-success",
                title: <h4>Welcome to the tournament!</h4>, 
                body:   
                <>
                <p>As a guest of the tournament, you will be allowed to attend the competition rooms live.  We ask that you strictly adhere to the following guidelines:</p>
                <ul className="normal">
                    <li className="normal">Mute immediately and stay muted the entire time you are in the room.</li>
                    <li className="normal">Do not use Raise Hand features, chat, or attempt to interact with anyone in the room.</li>
                </ul>
                <p>You will be able to follow the postings for each round and thereby decide which rooms to attend.  You will also be able to interact with others in the Student Hangout / Announcements Hall.</p>
                <br/>
                <p>Have fun!</p>
                </>                                                
            }
        }        
    }

    renderStepJudge(status) {
        switch(status) {
            case "Setting Availability":
            return {
                color: "bg-danger",
                title: <h4>Tell us when you can judge</h4>, 
                body: 
                <>
                <p ><strong style={{color: "red"}}>Note for parents trying to register their students:</strong> Each competitor and judge <em>must create their own account</em> and fill out there own profile.  If you are registering your student, <span style={{textDecoration: "underline"}}>please log out of your account and create an account in your student's name</span> in order to register them. The logout button is at the top right of the menu. Once they fill out their profile as a competitor, they will see the [Register for Events] Card which will allow them to register and pay.</p>
                <p>In order for us to assign rounds in a timely fashion, we need to know which rounds you will be available for judging.  By clicking on the [Judge Availability] Card below, you can select the rounds that work for your schedule. </p>
                </>
            }               

            case "Available": 
            return {
                color: "bg-warning",
                title: <h4>Thanks for telling us about your available times. </h4>, 
                body: 
                <>
                <p>Once the registration period closes, please check back in and setup your conflicts and designate the competitor that you are representing at this tournament.  Your designated competitor will not be able to compete unless you perform this step.  If you have no designated competitor than you do not need to concern yourself with this.  But you may still want to identify your conflicts in the [Conflicts of Interest] Card.</p>
                <p>Also, please check back to the tournament page 20 minutes before each round begins to the check your room assignments and accept a room to judge. You will do this by clicking on your [Review Postings] Card. </p>
                <p ><strong style={{color: "red"}}>Note for parents trying to register their students:</strong> Each competitor and judge <em>must create their own account</em> and fill out there own profile.  If you are registering your student, <span style={{textDecoration: "underline"}}>please log out of your account and create an account in your student's name</span> in order to register them. The logout button is at the top right of the menu. Once they fill out their profile as a competitor, they will see the [Register for Events] Card which will allow them to register and pay.</p>
                </>
            } 

            case "Judging": 
            return {
                color: "bg-success",
                title: <h4>Thanks for accepting a room assignment</h4>, 
                body: <p>You can find your room by clicking on the [Room Assignment] Card below.  Once in your room, you can use the Ballot link to fill out a ballot.  You can click the Video Room link to enter the Video room. Once you submit your ballot, you will be returned to the main tournament page in order to prepare for the next round.</p>
            } 

            case "Ready!": 
            return {
                color: "bg-success",
                title: <h4>Between Rounds ... </h4>, 
                body: 
                <>
                <p>Please continue to keep your availability up to date by clicking on the [Judge Availability] Card below.  You can select the rounds that work for your schedule.   </p>
                <p>Also, please remember to check the Room Assignments once the round has posted in order to select a room to judge for that round. </p>
                </>
            } 

            default: 
            return {
                title: <h4>Welcome to the tournament!</h4>, 
                body: <p>Let's get you setup to participate. To get started, please click the Edit Profile button to the right (or below) and configure your tournament profile.  This information will only be used to ensure proper room assignments during the tournament and in case of the need to immediately contact you. </p>
            }
        }
    }

    renderStepCompetitor(status) {
        switch(status) {
            case "Registering":
            return {
                color: "bg-danger",

                title: <h4>Registering for Events</h4>, 
                body: <p>As a competitor, you'll want to register for your events.  You can do this by clicking on the [Register for Events] Card below.' </p>
            }
            
            case "Ready!": 
            return {
                color: "bg-success",
                title: <h4>Have fun!</h4>, 
                body: <>
                <p> You've done everything you need to do to prepare for the tournament.  You can now enjoy your competition.  Feel free to hang out in the Student HangOut Hall. </p>
                <p> Just make sure you check the [Review Postings] Card (which will appear when the tournament opens) to see the rooms in which you will be competing.  Each round will be posted when all the ballots from the previous round have been turned in by the judges. </p>
                </>
            } 

            default: 
                if (status.startsWith("Waiting"))
                {
                    const step = {
                        color: "bg-warning",
                        title: <h4>Finalizing your Registration</h4>,
                        body: []
                    }
                    if (status.includes("Payment")) {
                        step.body.push(<p>Please make sure you have paid for your events.  You can do this by going back into the [Register for Events] Card. </p>)
                    }
                    if (status.includes("Partner")) {
                        step.body.push(<p>It looks like you have registered for some team events.  You will need to follow-up with your partner.  Once they have created an account, setup their profile in the tournament, and listed you as their partner,  you will be all set in this area. </p>)
                    }                    
                    if (status.includes("Judge")) {
                        step.body.push(<>
                        <p>You will want to follow-up with your designated judge to make sure they create an account, set up their profile, and mark you as their designated competitor in their [Conflict of Interest] Card.  They will also need to make themselves available for at least {this.state.tData.judgeRoundMin} rounds. </p>
                        <p>The judge can mark their availability now, but they will not be able to mark their designations or conflicts until registration closes.  So your status will indicate waiting on judge during the registration period. </p>
                        </>
                        )
                    }
                    return step;
                } else {
                    return {
                        color: "bg-danger",
                        title: <h4>Registering for Events</h4>, 
                        body: <p>As a competitor, you'll want to register for your events.  You can do this by clicking on the [Register for Events] Card below.' </p>
                    }                    
                }
        }
    }

    renderStep() {
        const { tUser } = this.state;
        if (!tUser || !(tUser.isJudge || tUser.isCompetitor || tUser.isGuest)) {
            return {
                color: "bg-info",
                title: <h4>Welcome to the tournament!</h4>, 
                body: <>
                <p>Let's get you setup to participate (Judge or Compete). To get started, please click the Edit Profile button to the right (or below) and configure your tournament profile.  Even if you are connecting as a guest, you will still need to complete this profile. This information will only be used to ensure proper room assignments during the tournament and in case of the need to immediately contact you.</p>
                <p>Along with setting up your profile, you can also go to your <Link to="/pages/dashboard">user dashboard</Link> and set up an avatar image that will be used to represent you in various places within the tournament.</p>
                </>
            }
        }

        if (tUser.isJudge) { return this.renderStepJudge(tUser.status) }
        if (tUser.isCompetitor) { return this.renderStepCompetitor(tUser.status) }
        if (tUser.isGuest) { return this.renderStepGuest(tUser.status) }

    }

    render() {     
        const { tData, user, tUser } = this.state;
        var status = tUser.status;
        const data = {
                club: user.club,
                experience: user.experience,
                gender: user.gender,
                age: user.ageGroup,
                phone: user.phone,
                judgeClass: tUser.judgeClass, // last two fields specific to tUser
                guestOfEmail: tUser.guestOfEmail
            }

        const step = this.renderStep();
        return (
                                        
        <TUserBox title="Tournament Guide" tData={tData} user={user} tUser={tUser}  controlKey="isGuideClosed">
            <div className="row">
                <div className="col-12 col-sm-6 col-md-8" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}>                                           
                    <div className="card" >
                        <div className="card-header" style={{paddingTop: "20px", paddingBottom: "0px"}}>
                            {step.title}                                           
                        </div>   

                        <div className="card-body" style={{paddingTop: "0px", paddingBottom: "0px"}}>
                            {step.body}
                        </div>
                        <div className="card-footer" style={{paddingTop: "0px", paddingBottom: "0px"}}>
                        &nbsp;
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-4" >

                    <div className="card" style={{marginBottom: "10px"}}>
                        <div className={`card-header ${step.color}`} style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                        </div>   

                        <div className={`card-body  ${step.color}`} style={{paddingTop: "0px", paddingBottom: "0px"}}>
                            <div className="dashboard">
                                <div className="box-account box-info" style={{fontSize: "16px"}}>
                                    <div className="row">
                                        <div className="col-9">
                                            {tUser.displayname}<br/>My Status: {status} { status !== 'Ready!' && status !== 'Available' && <>--- <button className="badge badge-info " onClick={this.onRefreshStatus}>Refresh</button></> }
                                        </div>
                                        <div className="col-3">
                                        {this.state.user && <><Link  className="float-right" to={`${process.env.PUBLIC_URL}/pages/dashboard`}><AvatarDisplay userId={this.state.user._id} size={48}/></Link></>  }                                      
                                        </div>
                                    </div>
                                </div>
                            </div>                                  
                        </div>
                        <div className={`card-footer ${step.color}`} style={{paddingTop: "0px", paddingBottom: "8px", borderTop: "none"}}>
                        </div>
                    </div> 


                    <div className="card">
                        <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px"}}>
                        </div>   

                        <div className="card-body" style={{paddingTop: "0px", paddingBottom: "0px"}}>
                            <div className="dashboard">
                                <div className="box-account box-info">
                                    <TournamentProfile 
                                        tournamentMode
                                        lockedJudgeClass={tUser.isRegistered || (tUser.isJudge && tUser.isAvailableComplete)}
                                        lockedOutCompetitors={!isBeforeDate(new Date(), new Date(tData.endRegDate))}
                                        data={data} 
                                        title="Tournament Profile"
                                        onCloseModal={this.onCloseTournamentProfileModal}
                                        readOnly={true}
                                    />  
                                </div>
                            </div>  
                        </div>
                        <div className="card-footer" style={{paddingTop: "0px", paddingBottom: "8px"}}>
                            &nbsp;
                        </div>
                    </div>    
                                                
                    
                </div>
            </div>
        </TUserBox>
                    
        )
    }
}

export default TournamentGuide;
